import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlNode } from '../ControlNode'

import { control } from './control'

/**
 * @param {string} name
 * @param {React.ReactNode} value
 * @param {Object} defaultProps
 */
export function node(name, value = null, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlNode, defaultProps)
}
